import React from 'react';
void React;
import { ReactComponent as KrinkelsK } from '../../assets/brand/Krinkels-K-outline.svg';

export default function KrinkelsKOutline({ className = '', style = {} }) {
  void KrinkelsK;
  return (
    <div className={`kr-k-outline ${className}`} aria-hidden="true" style={{ pointerEvents: 'none', ...style }}>
      <KrinkelsK focusable="false" role="img" aria-hidden="true" style={{ width: '100%', height: 'auto', color: 'var(--kr-green)' }} />
    </div>
  );
}
